import { render, staticRenderFns } from "./AttributeStatsDialog.vue?vue&type=template&id=14532896&scoped=true&"
import script from "./AttributeStatsDialog.vue?vue&type=script&lang=js&"
export * from "./AttributeStatsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AttributeStatsDialog.vue?vue&type=style&index=0&id=14532896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14532896",
  null
  
)

export default component.exports